module.exports = __webpack_public_path__ + "static/img/gjf-rmfy.c76c461.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/gjf-rmfy.jpg
// module id = fJPC
// module chunks = 1